module.exports = __webpack_public_path__ + "846a7278a132c794c8a1fda503a7eff0.MP3";